import * as React from 'react'
import dynamic from 'next/dynamic'

import {t} from '@lib/helpers'
import {AISolutionDetailLayout} from '@components/ai'

const Meta = dynamic(() => import('@components/Meta'))

export default function Automotive() {
  return (
    <React.Fragment>
      <Meta title={`Automotive | Datawow – ${t('layout.title')}`} />

      <section className='AISolutionDetail__introduction'>
        <div className='container'>
          <div className='grid grid--max-left'>
            <h1>
              <small>ตัวอย่าง AI Use Case ทางด้าน</small>
              Automotive
            </h1>
            <div>
              <p>
                อุตสาหกรรมยานยนต์เป็นหนึ่งในกลุ่มอุตสาหกรรมที่เริ่มใช้ AI ในช่วง
                4-5 ปีหลังมานี้ โดยในขณะนี้ถูกจัดอันดับให้เป็นกลุ่มที่มีการใช้
                AI ในระดับปานกลางนำหน้ากลุ่ม Oil & Gas
                แต่ยังคงตามหลังกลุ่มการเงินและค้าปลีก ในปี 2020
                มีการสำรวจโรงงานอุตสาหกรรมยานยนต์กว่า 500 แห่งทั่วโลก พบว่า
                มากกว่า 25% ของโรงงานเหล่านั้นเริ่มมีการนำ AI มาใช้จริง
                และมีเพียง 26% เท่านั้นที่ยังไม่ได้เริ่มวางแผนหรือพัฒนา AI
              </p>
              <p>
                เมื่อสำรวจลึกลงไปถึงตัวอย่าง use case ของ AI ในอุตสาหกรรมนี้
                พบว่า AI ถูกนำมาใช้ตั้งแต่การทำ research & development (R&D)
                เพื่อออกแบบยานยนต์ การผลิต ไปจนถึงการขาย และการบริการหลังการขาย
                โดยเราจะนำเสนอตัวอย่าง use case
                ในแต่ละขั้นตอนที่ถูกใช้จริงในบริษัทรถยนต์แต่ละแห่ง
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className='AISolutionDetail__feature-img'>
        <img
          src='/images/ai/automotive/feature1.jpg'
          srcSet='/images/ai/automotive/feature1@2x.jpg 2x'
          alt='Automotive'
        />
      </section>

      <section className='AISolutionDetail__section'>
        <div className='container'>
          <div className='grid grid--max-right'>
            <div>
              <h2>ตัวอย่างการใช้ AI ในกระบวนการ R&D</h2>
              <p>
                ในปี 2018 บริษัท General Motor (GM) และ Autodesk
                ได้ร่วมมือกันเพื่อพัฒนาระบบ AI ชื่อว่า Dreamcatcher
                ซึ่งมีความสามารถในการออกแบบชิ้นส่วนต่าง ๆ ในรูปแบบสามมิติจาก
                requirement ที่กำหนดให้ เช่น
                จุดประสงค์หรือการใช้งานของชิ้นงานนั้น ๆ วัสดุที่ ต้องการใช้
                กระบวนการผลิต และน้ำหนักที่มากที่สุดที่เป็นไปได้ของชิ้นส่วนนั้น
                จากนั้น AI จะออกแบบชิ้นส่วนนั้น ๆ
                ที่มีประสิทธิภาพมากที่สุดภายใต้ต้นทุนที่ต่ำที่สุด โดยระบบ
                Dreamcatcher ทำให้บริษัท GM
                สามารถออกแบบตัวยึดเข็มขัดนิรภัยที่มีความแข็งแรงมากขึ้น 20%
                แต่มีน้ำหนักเบาลงถึง 40% เมื่อเทียบกับการออกแบบโดยมนุษย์
              </p>
            </div>
            <img
              src='/images/ai/automotive/feature2.jpg'
              srcSet='/images/ai/automotive/feature2@2x.jpg 2x'
              alt='Automotive'
              loading='lazy'
              className='lg'
            />
          </div>
        </div>
      </section>

      <section className='AISolutionDetail__section AISolutionDetail__section--light'>
        <div className='container'>
          <h2>
            ตัวอย่างการใช้ AI<span>ในการผลิต</span>
          </h2>

          <div className='grid grid--max-left'>
            <img
              src='/images/ai/automotive/feature3.jpg'
              srcSet='/images/ai/automotive/feature3@2x.jpg 2x'
              alt='Automotive'
              loading='lazy'
              className='lg'
            />

            <p>
              ถ้ากล่าวถึงการใช้ AI ในการผลิตรถยนต์นั้น
              คนส่วนมากอาจจะนึกถึงการใช้หุ่นยนต์ในการประกอบชิ้นส่วนรถยนต์เข้าด้วยกันอย่างอัตโนมัติ
              แต่ในความเป็นจริงยังมี use case อื่น ๆ ของ AI
              ที่สามารถพัฒนาได้ง่ายภายใต้ต้นทุนที่ต่ำ ตัวอย่างหนึ่งคือการใช้ AI
              ควบคู่กับกล้องเพื่อทำการควบคุมคุณภาพการผลิต เช่น
              ตรวจจับรอยขีดข่วนบนชิ้นงานตรวจสอบชิ้นส่วนหรือสีของอุปกรณ์ว่าประกอบได้ตรงกับรุ่นที่ต้องการ
              หรือติดสัญลักษณ์ต่าง ๆ ถูกตำแหน่งหรือไม่
              ซึ่งช่วยลดเวลาที่ต้องใช้คนในการเดินตรวจสิ่งต่าง ๆ
              รอบคันไปได้มากทีเดียว ในปัจจุบันบริษัทรถยนต์ขนาดใหญ่อย่างเช่น
              Audi, และ Volkswagen ได้เริ่มใช้เทคโนโลยีกันบ้างแล้ว
            </p>
          </div>

          <img
            src='/images/ai/automotive/feature3.jpg'
            srcSet='/images/ai/automotive/feature3@2x.jpg 2x'
            alt='Automotive'
            loading='lazy'
            className='sm'
          />
        </div>
      </section>

      <section className='AISolutionDetail__card'>
        <div className='container'>
          <h2>ตัวอย่างการใช้ AI ในการขาย</h2>
          <div className='AISolutionDetail__card__body'>
            <div>
              <p>
                เช่นเดียวกันกับธุรกิจใน sector อื่น ๆ ที่มีการใช้ Big Data และ
                AI ในการวิเคราะห์ข้อมูลเพื่อพัฒนาการขาย
                ในธุรกิจรถยนต์อย่างเช่นบริษัท Volkswagen ได้มีการพัฒนา AI
                เพื่อพยากรณ์ยอดขายของรถยนต์มากกว่า 250 รุ่น ใน 120 ประเทศทั่วโลก
                โดยพิจารณาจากหลายปัจจัยด้วยกัน เช่น ปัจจัยด้านเศรษฐกิจ
                ด้านสภาพอากาศ ภูมิประเทศ เป็นต้น
              </p>
              <p>
                ซึ่งระบบนี้ทำให้ Volkswagen
                สามารถวางแผนการผลิตและจัดส่งได้อย่างมีประสิทธิภาพ นอกจากนี้
                Volkswagen ยังได้ใช้ AI
                เพื่อเลือกช่องทางการโฆษณาเพื่อให้โฆษณาถึงกลุ่มเป้าหมายมากที่สุดซึ่งช่วยเพิ่มยอดขายได้มากกว่าการยิงโฆษณาแบบสุ่ม
              </p>
            </div>

            <img
              src='/images/ai/automotive/feature4.jpg'
              srcSet='/images/ai/automotive/feature4@2x.jpg 2x'
              loading='lazy'
              alt='Automotive'
            />
          </div>
        </div>
      </section>

      <section className='AISolutionDetail__section AISolutionDetail__section--dark'>
        <div className='container'>
          <h2>ตัวอย่างการใช้ AI ในบริการหลังการขาย และการซ่อมบำรุง</h2>

          <div className='grid grid--max-left'>
            <img
              src='/images/ai/automotive/feature5.jpg'
              srcSet='/images/ai/automotive/feature5@2x.jpg 2x'
              alt='Automotive'
              loading='lazy'
              className='lg'
            />
            <div>
              <p>
                ทุกวันนี้มีบริการติดตั้งอุปกรณ์ Internet of Things (IoT) หรือ
                sensor บนรถยนต์เพื่อให้เก็บข้อมูลต่าง ๆ เช่น เสียง,
                การสั่นสะเทือน และส่งข้อมูลมายัง application บนมือถือ ซึ่งมีระบบ
                AI ที่ช่วยวิเคราะห์ข้อมูลต่าง ๆ เพื่อทำการประมาณ
                เวลาที่ควรจะเปลี่ยนอะไหล่แต่ละชิ้นในครั้งต่อไป
                นอกจากนี้ยังช่วยหาการทำงานที่ผิดปกติ
                และแจ้งเตือนให้ผู้ใช้รถทราบทำให้ซ่อมบำรุงได้อย่างทันท่วงทีก่อนจะก่อความเสียหายได้อีกด้วย
              </p>
              <p>
                โดยบริษัท Volvo
                ได้มีการทดลองใช้เทคโนโลยีนี้กับรถบรรทุกและพบว่าสามารถลดระยะเวลาที่ใช้ในการวิเคราะห์จุดชำรุดได้ถึง
                70% และลดเวลาการซ่อมแซมได้ถึง 20%
                เนื่องจากทางศูนย์ซ่อมสามารถวางแผนสั่งซื้ออะไหล่ได้ล่วงหน้า
                ซึ่งการลด downtime
                ของรถยนต์นั้นช่วยเพิ่มความสามารถในการทำรายได้ให้กับบริษัทขนส่งต่าง
                ๆ ได้อย่างมีนัยสำคัญ
              </p>
            </div>
          </div>

          <img
            src='/images/ai/automotive/feature5.jpg'
            srcSet='/images/ai/automotive/feature5@2x.jpg 2x'
            alt='Simulation and Optimization'
            loading='lazy'
            className='sm'
          />
        </div>
      </section>
    </React.Fragment>
  )
}

Automotive.getLayout = function getLayout(page: React.ReactElement) {
  return <AISolutionDetailLayout>{page}</AISolutionDetailLayout>
}
